var _g, _g2, _g3, _g4, _rect, _path, _path2, _path3, _g5, _g6, _g7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricingIcon01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 108,
    viewBox: "0 0 109 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1195_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 25.8986,
    width: 57,
    height: 56.2028,
    rx: 28.1014,
    fill: "url(#paint0_linear_1195_1528)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -7,
    y: -8,
    width: 123,
    height: 123
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(16.5px)",
      clipPath: "url(#bgblur_0_1195_1528_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 33
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 53.5,
    r: 28.5,
    fill: "white",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 53.5,
    r: 28,
    stroke: "white",
    strokeOpacity: 0.42
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1195_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 31,
    width: 47,
    height: 45,
    rx: 22.5,
    fill: "url(#paint1_linear_1195_1528)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -9,
    y: -10,
    width: 127,
    height: 127
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(20px)",
      clipPath: "url(#bgblur_1_1195_1528_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1195_1528)",
    "data-figma-bg-blur-radius": 40
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 31,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "url(#paint2_radial_1195_1528)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 30.5,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "url(#paint3_linear_1195_1528)",
    shapeRendering: "crispEdges"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 32,
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "#00020F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.8335 48.6832C63.7928 48.6036 63.7287 48.5381 63.65 48.4957L55.2054 44.0512C55.1416 44.0176 55.0705 44 54.9983 44C54.9261 44 54.8551 44.0176 54.7912 44.0512L46.3466 48.4957C46.268 48.5382 46.2041 48.6034 46.1631 48.6828L54.9983 53.3335L63.8335 48.6832Z",
    fill: "url(#paint4_linear_1195_1528)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9983 53.3335L54.9987 64C55.0709 64 55.1419 63.9825 55.2058 63.9489L63.6504 59.5044C63.722 59.4667 63.782 59.4101 63.8238 59.3408C63.8656 59.2715 63.8877 59.1921 63.8877 59.1111V48.8888C63.8869 48.8169 63.8681 48.7464 63.8335 48.6832L54.9983 53.3335Z",
    fill: "url(#paint5_linear_1195_1528)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1631 48.6828C46.1287 48.7461 46.1103 48.8168 46.1094 48.8889V59.1111C46.1094 59.1921 46.1315 59.2715 46.1733 59.3408C46.2151 59.4102 46.2751 59.4667 46.3467 59.5045L54.7913 63.9489C54.8551 63.9825 54.9265 64 54.9987 64L54.9983 53.3335L46.1631 48.6828Z",
    fill: "url(#paint6_linear_1195_1528)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 38.748,
    y: 36,
    width: 32.5054,
    height: 20.0001
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.5px)",
      clipPath: "url(#bgblur_2_1195_1528_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_1195_1528)",
    "data-figma-bg-blur-radius": 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2533 46.0248C68.1921 45.9053 68.0961 45.8072 67.9779 45.7434L55.3113 39.0768C55.2155 39.0264 55.1089 39 55.0006 39C54.8924 39 54.7858 39.0264 54.69 39.0768L42.0234 45.7434C41.9055 45.8072 41.8095 45.905 41.748 46.0241L55.0006 53.0001L68.2533 46.0248Z",
    fill: "url(#paint7_linear_1195_1528)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.001 39.5C55.0279 39.5001 55.0543 39.507 55.0781 39.5195L67.3086 45.9561L55 52.4346L42.6914 45.9561L54.9229 39.5195C54.9468 39.5069 54.9739 39.5 55.001 39.5Z",
    stroke: "url(#paint8_linear_1195_1528)",
    strokeOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 52,
    y: 43.0244,
    width: 19.3335,
    height: 28.9753
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.5px)",
      clipPath: "url(#bgblur_3_1195_1528_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_1195_1528)",
    "data-figma-bg-blur-radius": 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 52.9997V68.9996C55.1082 68.9997 55.2149 68.9734 55.3107 68.923L67.9773 62.2563C68.0847 62.1997 68.1747 62.1149 68.2374 62.0109C68.3001 61.9069 68.3333 61.7878 68.3333 61.6663V46.3331C68.3321 46.2251 68.3044 46.1191 68.2526 46.0244L55 52.9997Z",
    fill: "url(#paint9_linear_1195_1528)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.833 61.666C67.833 61.6964 67.8253 61.7269 67.8096 61.7529C67.7939 61.7788 67.7709 61.7994 67.7441 61.8135L55.5 68.2578V53.3008L67.833 46.8096V61.666Z",
    stroke: "url(#paint10_linear_1195_1528)",
    strokeOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 38.666,
    y: 43.0239,
    width: 19.3335,
    height: 28.9758
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.5px)",
      clipPath: "url(#bgblur_4_1195_1528_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_1195_1528)",
    "data-figma-bg-blur-radius": 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7467 46.0239C41.6951 46.119 41.6674 46.2251 41.666 46.3333V61.6665C41.666 61.788 41.6991 61.9071 41.7619 62.0111C41.8246 62.1151 41.9146 62.1999 42.022 62.2565L54.6886 68.9231C54.7844 68.9735 54.891 68.9999 54.9993 68.9998V52.9999L41.7467 46.0239Z",
    fill: "url(#paint11_linear_1195_1528)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.499 53.3003V68.2583L42.2549 61.814C42.2281 61.7998 42.2061 61.7784 42.1904 61.7524C42.1748 61.7265 42.166 61.6968 42.166 61.6665V46.8091L54.499 53.3003Z",
    stroke: "url(#paint12_linear_1195_1528)",
    strokeOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1195_1528",
    x: 0.1,
    y: -0.00144005,
    width: 108.8,
    height: 108.003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.95,
    result: "effect1_foregroundBlur_1195_1528"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1195_1528_clip_path",
    transform: "translate(7 8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 53.5,
    r: 28.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1195_1528",
    x: 5.1,
    y: 5.1,
    width: 98.8,
    height: 96.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.95,
    result: "effect1_foregroundBlur_1195_1528"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1195_1528",
    x: -9,
    y: -10,
    width: 127,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1195_1528"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.108041 0 0 0 0 0.0366146 0 0 0 0 0.2375 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1195_1528"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1195_1528",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_1195_1528_clip_path",
    transform: "translate(9 10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 31,
    width: 45,
    height: 45,
    rx: 22.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_1195_1528",
    x: 38.748,
    y: 36,
    width: 32.5054,
    height: 20.0001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1195_1528"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_1195_1528_clip_path",
    transform: "translate(-38.748 -36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2533 46.0248C68.1921 45.9053 68.0961 45.8072 67.9779 45.7434L55.3113 39.0768C55.2155 39.0264 55.1089 39 55.0006 39C54.8924 39 54.7858 39.0264 54.69 39.0768L42.0234 45.7434C41.9055 45.8072 41.8095 45.905 41.748 46.0241L55.0006 53.0001L68.2533 46.0248Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_1195_1528",
    x: 52,
    y: 43.0244,
    width: 19.3335,
    height: 28.9753,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1195_1528"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_1195_1528_clip_path",
    transform: "translate(-52 -43.0244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 52.9997V68.9996C55.1082 68.9997 55.2149 68.9734 55.3107 68.923L67.9773 62.2563C68.0847 62.1997 68.1747 62.1149 68.2374 62.0109C68.3001 61.9069 68.3333 61.7878 68.3333 61.6663V46.3331C68.3321 46.2251 68.3044 46.1191 68.2526 46.0244L55 52.9997Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_1195_1528",
    x: 38.666,
    y: 43.0239,
    width: 19.3335,
    height: 28.9758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1195_1528"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_4_1195_1528_clip_path",
    transform: "translate(-38.666 -43.0239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7467 46.0239C41.6951 46.119 41.6674 46.2251 41.666 46.3333V61.6665C41.666 61.788 41.6991 61.9071 41.7619 62.0111C41.8246 62.1151 41.9146 62.1999 42.022 62.2565L54.6886 68.9231C54.7844 68.9735 54.891 68.9999 54.9993 68.9998V52.9999L41.7467 46.0239Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1195_1528",
    x1: 22.1459,
    y1: 72.7043,
    x2: 82.4521,
    y2: 25.1026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1195_1528",
    x1: 27.8221,
    y1: 68.476,
    x2: 76.4184,
    y2: 28.9728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1195_1528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.8966 39.1383) rotate(70.9776) scale(37.1342 35.7953)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E29A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C32FE",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1195_1528",
    x1: 38.6094,
    y1: 28.1071,
    x2: 86.0007,
    y2: 56.1711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193043,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.620233,
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1195_1528",
    x1: 46.1094,
    y1: 44,
    x2: 67.3213,
    y2: 48.7878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1195_1528",
    x1: 46.1094,
    y1: 44,
    x2: 67.3213,
    y2: 48.7878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1195_1528",
    x1: 46.1094,
    y1: 44,
    x2: 67.3213,
    y2: 48.7878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1195_1528",
    x1: 41.748,
    y1: 39,
    x2: 68.7446,
    y2: 51.9779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#85A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1195_1528",
    x1: 42.5763,
    y1: 39.6364,
    x2: 68.2533,
    y2: 39.6364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1195_1528",
    x1: 55,
    y1: 46.0244,
    x2: 71.3635,
    y2: 48.4357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#85A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1195_1528",
    x1: 55.4167,
    y1: 47.0687,
    x2: 68.3333,
    y2: 47.0687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1195_1528",
    x1: 41.666,
    y1: 46.0239,
    x2: 58.0295,
    y2: 48.4351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#85A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1195_1528",
    x1: 42.0827,
    y1: 47.0683,
    x2: 54.9993,
    y2: 47.0683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingIcon01);
export default __webpack_public_path__ + "assets/media/pricing-icon01.462f8e3585d495e36b751599a4677cb9.svg";
export { ForwardRef as ReactComponent };